import { render, staticRenderFns } from "./NumberOfDependentsSelect.vue?vue&type=template&id=1c3dea8f"
import script from "./NumberOfDependentsSelect.vue?vue&type=script&lang=js"
export * from "./NumberOfDependentsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3dea8f')) {
      api.createRecord('1c3dea8f', component.options)
    } else {
      api.reload('1c3dea8f', component.options)
    }
    module.hot.accept("./NumberOfDependentsSelect.vue?vue&type=template&id=1c3dea8f", function () {
      api.rerender('1c3dea8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/user/NumberOfDependentsSelect.vue"
export default component.exports